import {getEventId} from '@wix/wix-events-commons-statics'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {isTicketedWithNoOrder} from '../../../selectors/event'
import {getEventTickets} from '../../../selectors/tickets'
import {downloadTickets, downloadTicketsWithNoOrder} from '../../../services/tickets'
import {EventLink} from '../../styled-components/event-link'
import {DownloadTicketsButtonProps} from './interfaces'

export const DownloadTicketsButton = ({event, order}: DownloadTicketsButtonProps) => {
  const {t} = useTranslation()
  const mobile = useMembersPageSelector(isMobile)

  const eventId = getEventId(event.event)
  const ticketedWithNoOrder = isTicketedWithNoOrder(event)
  const eventTickets = useMembersPageSelector(state => getEventTickets(state, eventId))

  const {downloadTicketsAction} = useMembersPageActions()

  const handleDownload = () => {
    ticketedWithNoOrder ? downloadTicketsWithNoOrder(eventTickets) : downloadTickets(order)
    downloadTicketsAction(eventId)
  }

  return (
    <EventLink
      secondary={true}
      mobile={mobile}
      onClick={handleDownload}
      data-hook={DH.BUTTON_DOWNLOAD_TICKETS}
      disabled={ticketedWithNoOrder && !eventTickets}
    >
      {t('events.buttons.download-tickets')}
    </EventLink>
  )
}
